<button
  mat-icon-button
  class="!bg-white !shadow-sm"
  matBadgeSize="small"
  matBadgeColor="warn"
  matTooltip="Filter by type"
  [matMenuTriggerFor]="filterMenu"
  [disabled]="disabled()"
  [matBadge]="selectedFiltersCount()"
  [matBadgeHidden]="!showClearButton()"
>
  <mat-icon>filter_list</mat-icon>
</button>

<mat-menu #filterMenu="matMenu">
  <div class="flex flex-col" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b px-4 py-2">
      <span class="text-sm">Filter by Type</span>
      @if (showClearButton()) {
        <button
          mat-icon-button
          matTooltip="Clear Filters"
          class="icon-md"
          (click)="clearFilters()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <mat-selection-list
      #selectionList
      [multiple]="true"
      (selectionChange)="onSelectionChange()"
    >
      @for (option of communicationTypeOptions(); track option.type) {
        <mat-list-option [value]="option.type">
          <div class="flex items-center gap-2">
            <mat-icon class="icon-sm">{{ option.icon }}</mat-icon>
            <span>{{ option.label }}</span>
          </div>
        </mat-list-option>
      }
    </mat-selection-list>
  </div>
</mat-menu>
